import { IFile } from 'src/app/app-modules/seller/seller-modules/auctions/_interfaces/horse.interface';

export interface Auction {
  id?: number;
  name?: string;
  slug?: string;
  is_public?: number;
  entry_data_start_date?: Date;
  preview_data_start_date?: Date;
  auction_start_date?: Date;
  auction_end_date?: Date;
  image?: IFile;
  auction_status?: any;

  updated_end_date_time?: Date;
  base_active_end_date?: Date | string;
  settings_end_date?: Date | string;
  active_timer_end_date?: Date | string;
  timer_end_date?: Date | string;

  highest_bid?: { id: number; amount: number };

  latest_media?: any;

  accepted_invited_buyer?: boolean;
  auction_buyer_last_record?: boolean;
  buyer_application_status?: boolean;
  end_date?: Date;
  ended?: boolean;
  extended_end_date?: Date;
  highest_bid_amount?: number;

  invited_buyer?: boolean;
  latest_bid_time?: number;
  request_to_join?: boolean;
  request_to_join_status?: boolean;
  running?: boolean;
  current_date?: Date;
  auc_type?: string;
  requestToBidClicked?: boolean;
  view_count?: number;
  auction_settings?: IAuctionSettings;
  min_bid?: number;
  buyer_document_categories?: IBuyerDocumentCategories[];
  gradual_ending_settings: any;
  seller_terms?: any;
  buyer_accepted_seller_terms?: string;
  seller: any;
  currency?: any;
  buyer_status?: {
    is_blocked: boolean;
    is_suspended: boolean;
    blocked_at: string | null;
    suspended_at: string | null;
  };
}
export interface IBuyerDocumentCategories {
  id?: number;
  name?: string;
}
export interface IAuctionSettings {
  accepted_invited_buyer?: boolean;
  buyer_application_status?: boolean;
  end_date?: Date;
  ended?: boolean;
  extended_end_date?: Date;
  highest_bid_amount?: number;
  highest_bid_amount_not_winning_items?: number;
  invited_buyer?: boolean;
  latest_bid_time?: Date;
  request_to_join?: boolean;
  request_to_join_status?: any;
  running?: boolean;
  updated_end_date_time?: Date;
  auction_start_date?: Date;
  entry_data_start_date?: Date;
  auction_buyer_last_record?: boolean;
}
export enum AuctionStatus {
  running = 'running',
}

// Horse/Auction Item Status Enum
export enum HorseStatus {
  Withdrawn = 'withdrawn',
  Winner = 'winner',
  Sold = 'sold',
  NotSold = 'not_sold',
  RNA = 'rna',
  PS = 'ps',  // Post Sale (offline)
  NoStatus = 'no_status',  // Admin override: ended with no outcome/price ("----")
  NoStatusHidePrice = 'no_status_hide_price',  // Admin override: ended, no badge, price row hidden
  NoStatusDashPrice = 'no_status_dash_price',  // Admin override: ended, no badge, price "----"
  NoStatusSale = 'no_status_sale'  // Admin override: ended, no badge, shows Latest Bid + Highest Bidder (legacy)
}

// Price Display Interface (from backend)
export interface DisplayPrice {
  label: string;      // "selling_price", "highest_bid", "latest_bid", "current_bid"
  amount: number;
  currency: string;
}

// Auction Item / Horse Interface
export interface AuctionItem {
  id: number;
  name: string;
  slug?: string;
  status?: HorseStatus;  // Unified status from backend

  // NEW: Centralized display data from backend
  display_price?: DisplayPrice;
  buyer_name?: string;  // Already masked from backend

  // Legacy fields (keep for backwards compatibility)
  rna_status?: boolean;
  highest_bid?: { id?: number; amount: number };
  reserve_price?: number;  // Admin only
  winner?: {
    price: number;
    won_at: string;
    is_offline: boolean;
  };

  // Auction settings
  can_bid?: boolean;
  in_user_wishlist?: boolean;

  // Flags
  withdrawn_at?: string | null;
  unsold_flag_at?: string | null;
  extended_end_date?: Date | string;

  // Horse details
  horse?: any;
  auction_pictures?: any[];

  // Other fields
  bids_count?: number;
  bidders_count?: number;
  auction_id?: number;
  auction?: Auction;
}
